import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "full"
}
const _hoisted_2 = {
  key: 1,
  class: "h-64"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_video_thumbnail_h_q = _resolveComponent("video-thumbnail-h-q")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_ctx.toArray(_ctx.videos).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_carousel, {
          "indicator-position": "outside",
          trigger: "click",
          arrow: "always",
          interval: 4000
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: video.id
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: `/video/${video.id}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_video_thumbnail_h_q, {
                        video: video,
                        rounded: false,
                        titleAlign: "text-center"
                      }, null, 8, ["video"])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2))
}